import classNames from 'classnames'

import Loader from 'Root/Loader'

import styles from './index.module.css'

export interface Props {
  fullscreen?: boolean
}

const Page = ({ fullscreen = false }: Props) => (
  <div
    className={classNames(
      'text-center flex',
      fullscreen ? 'h-screen' : styles.full
    )}
  >
    <Loader className={styles.loader} />
  </div>
)

export default Page
